// Centralized auth token storage.
// Uses sessionStorage so the login does NOT persist after the tab/browser closes
// (incognito-like behavior — important on shared computers). Existing localStorage
// tokens are migrated over transparently so current users aren't force-logged-out.

const TOKEN_KEY = "token";

export const getToken = (): string | null => {
  const fromSession = sessionStorage.getItem(TOKEN_KEY);
  if (fromSession) return fromSession;

  // One-time migration: move any persistent token into sessionStorage
  const legacy = localStorage.getItem(TOKEN_KEY);
  if (legacy) {
    sessionStorage.setItem(TOKEN_KEY, legacy);
    localStorage.removeItem(TOKEN_KEY);
    return legacy;
  }
  return null;
};

export const setToken = (token: string): void => {
  sessionStorage.setItem(TOKEN_KEY, token);
  localStorage.removeItem(TOKEN_KEY); // never keep it in persistent storage
};

// Wipe everything auth-related from both stores (used on logout / 401).
export const clearAuthStorage = (): void => {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
};
